import React from "react";
import { Button, Container } from "react-bootstrap";

export default function Chef() {
    const handleEnrollClick = () => {
        const whatsappNumber = "9445744663";
        const message = "Hello, I am interested in enrolling for the pastry course!"; // Customize the message as needed
        const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

        // Open WhatsApp link in a new tab
        window.open(whatsappLink, "_blank");
    };
    return (
        <>
        <Container className="chef-space">
            <div className="chef_bg">
                <div className="chef-text">
                    <div className="head-send">
                        <div className="main-head">
                            <h1>Dreaming of a Career in Pastry?</h1>
                            <p>Start Your Journey with Us!</p>
                        </div>
                        <div className="send-btn">
                            <Button className="centered-button" onClick={handleEnrollClick}>Enroll Now</Button>
                        </div>
                    </div>
                </div>
            </div>
            </Container>
        </>
    )
}